import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductPriceRangeFragmentDoc } from './ProductPriceRange.generated';
export type SocialPostFragment = { id: string, created: any, externalLink: string, link: string, name: string, sortOrder: number, type: string, description: string, status: string, username: string, images: Array<{ id: string, url: string, thumbnailUrl: string | null }> };

export type SocialPostWithProductsFragment = { id: string, created: any, externalLink: string, link: string, name: string, sortOrder: number, type: string, description: string, status: string, username: string, relatedProducts: Array<{ id: string, pk: number, thumbnailUrl: string | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, specifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string }> }>, images: Array<{ id: string, url: string, thumbnailUrl: string | null }> };

export const SocialPostFragmentDoc = gql`
    fragment SocialPostFragment on PostType {
  id
  created
  externalLink
  link
  name
  sortOrder
  type
  description
  status
  username
  images {
    id
    url
    thumbnailUrl: thumbnailUrl(size: "200x0", method: THUMBNAIL_WEBP)
  }
}
    `;
export const SocialPostWithProductsFragmentDoc = gql`
    fragment SocialPostWithProductsFragment on PostType {
  ...SocialPostFragment
  relatedProducts {
    id
    pk
    thumbnailUrl(method: THUMBNAIL_WEBP, size: "600x0")
    priceRange {
      ...ProductPriceRangeFragment
    }
    specifics(filters: {siteSpecifics: true}) {
      id
      pk
      name
      shortName
      slug
    }
  }
}
    ${SocialPostFragmentDoc}
${ProductPriceRangeFragmentDoc}`;